import { z } from 'zod';

export const ScraperOperationUiSchema = z.object({
  titulo: z.string(),
  exito: z.boolean()
});

export const ScraperInfoUiSchema = z.object({
  id: z.number().nullable().optional(),
  fechaInicio: z.string().nullable().optional(),
  fechaFin: z.string().nullable().optional(),
  totalTimeSeg: z.number().nullable().optional(),
  fechaInicioFormatted: z.string().nullable().optional(),
  fechaFinFormatted: z.string().nullable().optional(),
  totalTimeFormatted: z.string().nullable().optional(),
  operaciones: z.array(ScraperOperationUiSchema).optional(),
  hasError: z.boolean(),
  error: z.string().nullable().optional()
});

export type ScraperOperationUi = z.infer<typeof ScraperOperationUiSchema>;
export type ScraperInfoUi = z.infer<typeof ScraperInfoUiSchema>;
